import { createReferralRoute } from "@talentpair/tracking";
import { londonLink } from "@talentpair/env";

export const CandidateReferralPage = createReferralRoute(londonLink.authCandidateSignup());
